import React, { useState } from 'react';
import Input from './AuthInput';
import Modal, { ModalCloseButton } from '../../shared/modals/Modal';

const ForgotPasswordModal = ({setVisible}) => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState(null);
  const closeModal = () => setVisible(false);

  const resetPassword = () => {
    fetch(process.env.REACT_APP_SERVER_URL + '/api/forgot-password', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ email: email.trim() })
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          setMessage('Please check your email for instructions.');
        }
        else {
          setMessage('Email not found');
        }
      })
  };

  return (
    <Modal isOpen={true} onClose={closeModal}>
      <div className="modal">
        <div className='modal__header'>
          <h3 className='margin-none'>Forgot password</h3>
          <ModalCloseButton
            onClick={closeModal}
            label="Close forgot password modal"
          />
        </div>

        {!message && (
          <>
            <div className="modal__body">
              <p>Enter your email address to receive a link to reset your password.</p>
              <Input label="Email"
                     value={email}
                     placeholder='Enter email'
                     type='email'
                     onChange={(e) => {
                       setEmail(e.target.value);
                     }}/>
            </div>
            <div className='modal__footer'>
              <button className='btn secondary'
                      onClick={closeModal}>
                Cancel
              </button>
              <button className='btn primary'
                      onClick={resetPassword}>
                Reset Password
              </button>
            </div>
          </>
        )}

        {message && (
          <>
            <div className="modal__body">
              <p>{message}</p>
            </div>
            <div className='modal__footer'>
              <button className='btn primary'
                      onClick={closeModal}>
                Close
              </button>
            </div>
          </>
        )}

      </div>
    </Modal>
  );
}

export default ForgotPasswordModal;
